import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ControlType } from "src/app/components/arcgis-map/constants/control-type.enum";
import { MapControlItem } from "src/app/components/arcgis-map/constants/map-control-item.interface";
import { ARCGIS_MAP_LIFECYCLE } from "src/app/components/arcgis-map/constants/map-life-cycle.interface";
import { MainMapService } from "src/app/components/arcgis-map/services/main-map.service";
@Component({
    selector: 'app-scientific-archive-map',
    templateUrl: './scientific-archive-map.component.html',
    styleUrls: ['./scientific-archive-map.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    	providers: [
		{
			provide: ARCGIS_MAP_LIFECYCLE,
			useClass: MainMapService,
		},
	]
})
export class ScientificArchiveMapComponent {
    @Input() shapes: any[] = [];
    @Input() zoomShapeIds: string[] = [];
    @Input() fromLocus = true;
    @Input() needZoom = true;
    @Input() header = '';
    @Output() handleLeftClick = new EventEmitter<any[]>();
	constructor(private translate: TranslateService) {}
 	mapControls: MapControlItem[] = [
		{ position: 'top-left', type: ControlType.FullScreen },
		{ position: 'top-left', type: ControlType.Zoom },
		{
			position: 'top-left',
			type: ControlType.BasemapGallery,
			expand: {
				id: 'basemap-gallery-expand',
				position: 'top-left',
				expandIcon: 'basemap',
				expandTooltip: '',
				mode: 'floating',
			},
		},
    {
			position: 'top-left',
			type: ControlType.LayerList,
			expand: {
				id: 'layer-list-expand',
				position: 'top-left',
				expandIcon: 'layers',
				expandTooltip: `${this.translate.instant('iaa.map.expand-layers')}`,
				mode: 'floating',
			},
		},
	];

    onShapeLeftClick($event: any) {
        this.handleLeftClick.emit();
    }



}